

import {
    Component,
    Injectable,
    inject
} from "@angular/core";

import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogModule,
} from "@angular/material/dialog";

import { lastValueFrom } from "rxjs";

import {
    BaseDialogService,
    NonNullableConfigData,
    TilbyDialogContentComponent,
    TilbyDialogToolbarComponent,
} from "@tilby/tilby-ui-lib/components/tilby-dialog";

import { CommonModule } from "@angular/common";

import {
    ConfigurationManagerService
} from "src/app/core";

import { TilbyCurrencyPipe } from "@tilby/tilby-ui-lib/pipes/tilby-currency";
import { SalesItems } from "tilby-models";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";

export type ItemDetailsDialogData = {
    saleItems: SalesItems[],
};

@Component({
    selector: "app-item-details-dialog",
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatDividerModule,
        MatIconModule,
        TilbyCurrencyPipe,
        TilbyDialogContentComponent,
        TilbyDialogToolbarComponent,
    ],
    templateUrl: "./item-details-dialog.component.html",
    styleUrls: ["./item-details-dialog.component.scss"],
})
export class TilbyDialogComponent {
    private readonly configurationManagerService = inject(ConfigurationManagerService);
    protected readonly data: ItemDetailsDialogData = inject(MAT_DIALOG_DATA);

    showPrices = this.configurationManagerService.isUserPermitted('show_prices_ui');
    saleItems = this.data.saleItems ?? [];
}

@Injectable({
    providedIn: "root",
})
export class ItemDetailsDialogService extends BaseDialogService {
    private readonly dialogRef = inject(MatDialog);

    public openDialog(config?: NonNullableConfigData<ItemDetailsDialogData>) {
        const data: ItemDetailsDialogData = config?.data ?? {
            saleItems: [],
        };

        const configEdited: NonNullableConfigData<ItemDetailsDialogData> = {
            ...config,
            ...this.switchMobileDesktopDimensions({ width: "800px" }),
            disableClose: true,
            data,
        };

        return lastValueFrom(
            this.dialogRef.open(TilbyDialogComponent, configEdited).afterClosed()
        );
    }
}
